import 'bootstrap/dist/css/bootstrap.min.css';
import React, { useContext, useEffect, useState } from 'react';
import { CloseButton, Col, Container, Image, Row, Spinner, Tab, Tabs, Table  } from 'react-bootstrap';
import * as Icon from 'react-bootstrap-icons';
import Category from './Category';
import Footer from './Footer';
import Header from './Header';
import { useTranslation } from "react-i18next";
import * as RIcon from "react-icons/fa"
import { Link, useLocation, useNavigate } from 'react-router-dom';
import CardRegist from './common/CardRegist';
import { Alert, Box, Button, Card, CardContent, CardHeader, CardMedia, Chip, FormControl, IconButton, InputAdornment, InputLabel, MenuItem, Select, Skeleton, Slider, Step, StepLabel, Stepper, TextField, Typography } from '@mui/material';
import ApiFetch from './ApiFetch';
import CommonDialog from './common/CommonDialog';
import LoadingButton from '@mui/lab/LoadingButton';
import DirectdebitRegist from './common/DirectdebitRegist';
import * as ImageUtil from '../service/ImageUtil';
import { LoginInfo } from '../App';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';

const IDConfirmation = () => {
	async function getCountries(){
        return await new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/profile/countries").then((r)=>r.json().then((json)=>{
            return json
        }))
    }
    async function baseIDRegist(sei,mei,seiKana,meiKana,sex,year,month,day,countryCode,postCode,prefecture,address1,address2,address3){
        return await new ApiFetch().post(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/profile/baseIDRegist",{
            sei:sei,mei:mei,seiKana:seiKana,meiKana:meiKana,sex:sex,year:year,month:month,day:day,countryCode:countryCode,postCode:postCode,prefecture:prefecture,address1:address1,address2:address2,address3:address3
        }).then((r)=>r.json().then((json)=>{
            return json
        }))
    }
    async function idImageRegist(identificationDiv,identificationImage1,identificationImage2,identificationImage3,identificationSelfie){
        return await new ApiFetch().post(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/profile/idImageRegist",{
            identificationDiv:identificationDiv,identificationImage1:identificationImage1,identificationImage2:identificationImage2,identificationImage3:identificationImage3,identificationSelfie:identificationSelfie
        }).then((r)=>r.json().then((json)=>{
            return json
        }))
    }
    async function getIDInfo(){
        return await new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/profile/id").then((r)=>r.json().then((json)=>{
            return json
        }))
    }
    function isValidDate(year, month, day) {
        // 月は0から11の範囲で表現されるため、1を引きます
        const date = new Date(year, month - 1, day);
        
        // 入力された年月日が有効な日付かどうかを確認します
        return (
            date.getFullYear() === year &&
            date.getMonth() === month - 1 &&
            date.getDate() === day
        );
    }
    const {t,i18n} = useTranslation()
    const navigate = useNavigate()
    // ログイン情報
    const {loginInfo,setLoginInfo} = useContext(LoginInfo)
    const location = useLocation()
    const [selected,setSelected] = useState(0)
    const [showRegistConfirm,setShowRegistConfirm] = useState(false)
    const [showDeleteConfirm,setShowDeleteConfirm] = useState(false)
    const [showDefaultConfirm,setShowDefaultConfirm] = useState(false)
    const [loadingPaymentStatus,setLoadingPaymentStatus] = useState(false)
    const [loadingPaymentDefault,setLoadingPaymentDefault] = useState(false)
    const [loading,setLoading] = useState(false)
    const [revenueInfo,setRevenueInfo] = useState([])
    const [payoutsHistory,setPayoutsHistory] = useState([])
    const [bankInfo,setBankInfo] = useState([])
    const [message,setMessage] = useState()
    const [sex,setSex] = useState(0)
    const [year,setYear] = useState(2000)
    const [month,setMonth] = useState(0)
    const [day,setDay] = useState(0)
    const [countries,setCountries] = useState([])
    const [countryCode,setCountryCode] = useState("")
    const [identificationDiv,setIdentificationDiv] = useState("")
    const [identificationLabel1,setIdentificationLabel1] = useState("")
    const [identificationLabel2,setIdentificationLabel2] = useState("")
    const [identificationLabel3,setIdentificationLabel3] = useState("")
    const [identificationImage1,setIdentificationImage1] = useState("")
    const [identificationImage2,setIdentificationImage2] = useState("")
    const [identificationImage3,setIdentificationImage3] = useState("")
    const [identificationSelfie,setIdentificationSelfie] = useState("")
    const [imageNo,setImageNo] = useState(0)
    const [prefecture,setPrefecture] = useState("")
    const [idInfo,setIDInfo] = useState([])
    const [activeStep,setActiveStep] = useState(-1)
    const [registedStatus,setRegistedStatus] = useState(-1)
    const [isCompleted,setIsCompleted] = useState(false)
    let param = location.search
    useEffect(() => {
        // 国一覧
        getCountries().then(r => {
            if(r.result){
                setCountries(r.data)
            }
        })
        getIDInfo().then(r => {
            if(r.result){
                setIDInfo(r.data)
                setActiveStep(r.data.status)
                setRegistedStatus(r.data.registed_status)
                setIsCompleted(r.data.registed_status === 3)
                if(r.data.status === 0 && r.data.registed_status === 4){
                    let reason = ""
                    if(r.data.registed_reason_for_remand === "MISMATCH"){
                        reason = "提出内容不一致・不備"
                    } else if(r.data.registed_reason_for_remand === "UNCLEAR"){
                        reason = "内容不明瞭"
                    } else if(r.data.registed_reason_for_remand === "PRIVATE"){
                        reason = "その他"
                    }
                    setMessage(<>
                        <div style={{textAlign:"left"}}>
                            審査が差し戻されました。再提出してください。{reason === "" ? "" : <>理由：{reason}</>}<br /><br />
                            <ul>
                                <li>対応する身分証か。マイナンバーカードにマイナンバーの記載がある場合はスキャンした後に黒塗りが必要です。</li>
                                <li>提出する身分証明書の内容通りの記載か</li>
                                <li>提出する身分証明書と実際に提出した画像は一致しているか</li>
                                <li>身分証の内容が鮮明に確認できるか</li>
                                <li>IDセルフィーで顔や身分証が一部隠れていないか</li>
                                <li>身分証明書に記載の住所や氏名、生年月日が申請内容と一致しているか</li>
                                <li>提出する身分証明書は有効期限内か(期限の記載がある場合)</li>
                            </ul>
                        </div>
                    </>)
                }
            }
        })
    },[])
    const steps = [
        '基本情報の入力',// 入力前後
        '身分証の提出',// 提出前後
        '身分証の確認',// 確認中、確認完了
      ];
    const years = [];
    for (let year = 1900; year <= new Date().getFullYear(); year++) {
        years.push(year);
    }
    const months = [];
    for (let month = 1; month <= 12; month++) {
        months.push(month);
    }
    const days = [];
    for (let day = 1; day <= 31; day++) {
        days.push(day);
    }
    const prefectures = [
        "北海道", "青森県", "岩手県", "宮城県", "秋田県", "山形県", "福島県",
        "茨城県", "栃木県", "群馬県", "埼玉県", "千葉県", "東京都", "神奈川県",
        "新潟県", "富山県", "石川県", "福井県", "山梨県", "長野県", "岐阜県",
        "静岡県", "愛知県", "三重県", "滋賀県", "京都府", "大阪府", "兵庫県",
        "奈良県", "和歌山県", "鳥取県", "島根県", "岡山県", "広島県", "山口県",
        "徳島県", "香川県", "愛媛県", "高知県", "福岡県", "佐賀県", "長崎県",
        "熊本県", "大分県", "宮崎県", "鹿児島県", "沖縄県","日本国外"
    ];
    useEffect(() => {
        if(identificationDiv === "PASSPORT"){
            setIdentificationLabel1("顔写真ページ")
            setIdentificationLabel2("住所記入欄ページ")
            setIdentificationLabel3("")
        } else if(identificationDiv === "HOKENSHOU_JUMINHYOU"){
            setIdentificationLabel1("健康保険証 表")
            setIdentificationLabel2("健康保険証 裏")
            setIdentificationLabel3("住民票")
        } else {
            setIdentificationLabel1("表")
            setIdentificationLabel2("裏")
            setIdentificationLabel3("")
        }
        setIdentificationImage1("")
        setIdentificationImage2("")
        setIdentificationImage3("")
        setIdentificationSelfie("")
    },[identificationDiv])
    return(
    <div className="wrapper" style={{backgroundColor:"#EEEEEE",borderRadius:"10px"}}>
        <header className="App-header"></header>
        <Header />
        <Category />
        <Container className='w-100'>
            <h4>本人確認</h4>
            <Row className='mb-4 text-left p-3' style={{backgroundColor:"#FFFFFF"}}>
                <Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12} style={{display:isCompleted ? "none" : "block"}}>
                    <Box sx={{ width: '100%' }}>
                        {activeStep === -1 ? [... Array(5)].map((d,i) => <Skeleton width={"100%"} height={50} animation="wave" />) :
                        <Stepper activeStep={activeStep} alternativeLabel>
                            {steps.map((label) => (
                            <Step key={label}>
                                <StepLabel>{label}</StepLabel>
                            </Step>
                            ))}
                        </Stepper>
                        }
                    </Box>
                </Col>
                <Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12}>
                    {activeStep === 0 && !isCompleted ? (
                        <Box className="p-3 mb-3">
                            <p>本人確認書類に記載された内容を記入してください。入力情報と異なる場合は再申請となります。</p>
                            <TextField
                                label="姓"
                                id="sei"
                                sx={{ m: 1, width: '25ch' }}
                            />
                            <TextField
                                label="名"
                                id="mei"
                                sx={{ m: 1, width: '25ch' }}
                            />
                            <br />
                            <TextField
                                label="セイ"
                                id="sei_kana"
                                sx={{ m: 1, width: '25ch' }}
                            />
                            <TextField
                                label="メイ"
                                id="mei_kana"
                                sx={{ m: 1, width: '25ch' }}
                            />
                            <br />
                            <FormControl sx={{ m: 1, minWidth: 120 }}>
                                <InputLabel id="sex-label">性別</InputLabel>
                                <Select
                                    labelId="sex-label"
                                    id="sex-code"
                                    label="Sex"
                                    onChange={(e) => {setSex(e.target.value)}}
                                >
                                    <MenuItem value="">
                                    <em>None</em>
                                    </MenuItem>
                                    {[{"code":1,"label":"男"},{"code":2,"label":"女"}].map(d => {
                                        return <MenuItem value={d.code}>{d.label}</MenuItem>
                                    })}
                                </Select>
                            </FormControl><br />
                            <FormControl sx={{ m: 1, minWidth: 120 }}>
                                <InputLabel id="year-label">誕生日(年)</InputLabel>
                                <Select
                                    labelId="year-label"
                                    id="year"
                                    label="Year"
                                    value={year}
                                    onChange={(e) => {setYear(e.target.value)}}
                                >
                                    <MenuItem value="">
                                    <em>None</em>
                                    </MenuItem>
                                    {[years.map(d => {
                                        return <MenuItem value={d}>{d}</MenuItem>
                                    })]}
                                </Select>
                            </FormControl>
                            <FormControl sx={{ m: 1, minWidth: 120 }}>
                                <InputLabel id="month-label">月</InputLabel>
                                <Select
                                    labelId="month-label"
                                    id="month"
                                    label="Month"
                                    onChange={(e) => {setMonth(e.target.value)}}
                                >
                                    <MenuItem value="">
                                    <em>None</em>
                                    </MenuItem>
                                    {[months.map(d => {
                                        return <MenuItem value={d}>{d}</MenuItem>
                                    })]}
                                </Select>
                            </FormControl>
                            <FormControl sx={{ m: 1, minWidth: 120 }}>
                                <InputLabel id="day-label">日</InputLabel>
                                <Select
                                    labelId="day-label"
                                    id="day"
                                    label="Day"
                                    onChange={(e) => {setDay(e.target.value)}}
                                >
                                    <MenuItem value="">
                                    <em>None</em>
                                    </MenuItem>
                                    {[days.map(d => {
                                        return <MenuItem value={d}>{d}</MenuItem>
                                    })]}
                                </Select>
                            </FormControl><br />
                            <FormControl sx={{ m: 1, minWidth: 120 }}>
                                <InputLabel id="country-label">国</InputLabel>
                                <Select
                                    labelId="country-label"
                                    id="country-code"
                                    label="Country"
                                    onChange={(e) => {setCountryCode(e.target.value)}}
                                >
                                    <MenuItem value="">
                                    <em>None</em>
                                    </MenuItem>
                                    {[countries.map(d => {
                                        return <MenuItem value={d.code}>{d.name} - {d.english_name}</MenuItem>
                                    })]}
                                </Select>
                            </FormControl><br />
                            <TextField
                                label="郵便番号"
                                id="post-code"
                                sx={{ m: 1, width: '25ch' }}
                            /><br />
                            <TextField
                                label="都道府県・州"
                                id="prefecture"
                                sx={{ m: 1, width: '25ch' }}
                            /><br />
                            <TextField
                                label="市区町村"
                                id="address1"
                                sx={{ m: 1, width: '25ch' }}
                            /><br />
                            <TextField
                                label="番地"
                                id="address2"
                                sx={{ m: 1, width: '25ch' }}
                            /><br />
                            <TextField
                                label="建物名・部屋番号"
                                id="address3"
                                sx={{ m: 1, width: '25ch' }}
                            /><br />
                        </Box>
                    ) : ""}
                    {activeStep === 1 ? (
                        <Box className="p-3 mb-3">
                            <h5 className='mt-3 mb-3'>提出する身分証明書の種類を選択してください。</h5>
                            <FormControl sx={{ m: 1, minWidth: 200 }}>
                                <InputLabel id="identification-div-label">提出する身分証明書</InputLabel>
                                <Select
                                    labelId="identification-div-label"
                                    id="identification-div"
                                    label="Identification"
                                    onChange={(e) => {
                                        setIdentificationDiv(e.target.value)
                                    }}
                                >
                                    <MenuItem value="">
                                    <em>None</em>
                                    </MenuItem>
                                    {[{"name":"マイナンバーカード","div":"MY_NUMBER"},{"name":"運転免許証","div":"DRIVERS_LICENCE"},{"name":"パスポート","div":"PASSPORT"},{"name":"運転経歴証明書","div":"DRIVERS_RECORD_CERTIFICATE"},
                                    {"name":"健康保険証＋住民票","div":"HOKENSHOU_JUMINHYOU"},{"name":"住民基本台帳カード","div":"JUMIN_KIHON_DAICHOU"},{"name":"特別永住者証明書","div":"TOKUBETSU_EIJU"},
                                    {"name":"居住国政府発行の身分証明書(日本国外居住者の場合)","div":"NIHON_KOKUGAI"}].map(d => {
                                        return <MenuItem value={d.div}>{d.name}</MenuItem>
                                    })}
                                </Select>
                            </FormControl><br />
                            {identificationDiv === "" ? "" : (<>
                            <h5 className='mt-3 mb-3'>画像を選択してください。</h5>
                            <input type="file" id={"file"} className='d-none' onChange={(e) => {
                                let files = e.target.files
                                ImageUtil.loadImageBig(files,(jpg) => {
                                    switch(imageNo){
                                        case 1:
                                            setIdentificationImage1(jpg)
                                        break
                                        case 2:
                                            setIdentificationImage2(jpg)
                                        break
                                        case 3:
                                            setIdentificationImage3(jpg)
                                        break
                                        case 4:
                                            setIdentificationSelfie(jpg)
                                        break
                                    }
                                    document.querySelector("#file").value = ""
                                },false)
                            }} />
                            ・{identificationLabel1} <Button variant='outlined' className='m-1' onClick={() => {setImageNo(1);document.querySelector("#file").click()}}>ファイルを選択{identificationImage1 === "" ? "" : <>&nbsp;<Icon.CheckCircleFill style={{color:"#007800"}} /></>}</Button>{identificationImage1 === "" ? "" : <IconButton variant='outlined' onClick={() => setIdentificationImage1("")}><Icon.Trash /></IconButton>}<br />
                            {identificationImage1 === "" ? "" : <><Image src={identificationImage1} style={{maxWidth:200,maxHeight:200}} /><br /><br /></>}
                            ・{identificationLabel2} <Button variant='outlined' className='m-1' onClick={() => {setImageNo(2);document.querySelector("#file").click()}}>ファイルを選択{identificationImage2 === "" ? "" : <>&nbsp;<Icon.CheckCircleFill style={{color:"#007800"}} /></>}</Button>{identificationImage2 === "" ? "" : <IconButton variant='outlined' onClick={() => setIdentificationImage2("")}><Icon.Trash /></IconButton>}<br />
                            {identificationImage2 === "" ? "" : <><Image src={identificationImage2} style={{maxWidth:200,maxHeight:200}} /><br /><br /></>}
                            {identificationLabel3 === "" ? "" : <>・{identificationLabel3} <Button variant='outlined' className='m-1' onClick={() => {setImageNo(3);document.querySelector("#file").click()}}>ファイルを選択{identificationImage3 === "" ? "" : <>&nbsp;<Icon.CheckCircleFill style={{color:"#007800"}} /></>}</Button>{identificationImage3 === "" ? "" : <IconButton variant='outlined' onClick={() => setIdentificationImage3("")}><Icon.Trash /></IconButton>}<br /></>}
                            {identificationImage3 === "" ? "" : <><Image src={identificationImage3} style={{maxWidth:200,maxHeight:200}} /><br /><br /></>}
                            ・IDセルフィー<Button variant='outlined' className='m-1' onClick={() => {setImageNo(4);document.querySelector("#file").click()}}>ファイルを選択{identificationSelfie === "" ? "" : <>&nbsp;<Icon.CheckCircleFill style={{color:"#007800"}} /></>}</Button>{identificationSelfie === "" ? "" : <IconButton variant='outlined' onClick={() => setIdentificationSelfie("")}><Icon.Trash /></IconButton>}<br />
                            {identificationSelfie === "" ? "" : <><Image src={identificationSelfie} style={{maxWidth:200,maxHeight:200}} /><br /><br /></>}
                            <h6 className='mt-3'>IDセルフィーとは</h6>
                            免許証などの本人確認書類を持ち、顔全体と同じ画面に収めて撮影した画像をいいます。<br />
                            身分証を持ち、自撮りします。<br />
                            <ul>
                                <li>身分証の記載事項が全て鮮明であること。</li>
                                <li>顔が隠れないこと。</li>
                            </ul>
                            <Image src='/img/id_selfie.webp' width={256} />
                            </>)}
                        </Box>
                    ) : ""}
                    <Box className="text-center">
                        {message !== undefined ? <Alert severity='warning'>{message}</Alert> : ""}
                        {/*registedStatus === 0 && loginInfo.id_auth === 0 && (loginInfo.plan === "" || loginInfo.plan === "basic") ? <Button onClick={() => navigate("/legal")} severity='success' variant='outlined' className='m-1' startIcon={<AutoAwesomeIcon />}>スタンダードプラン以上に登録して、本人確認する。</Button> : ""*/}
                        {activeStep === 2 ? <Alert severity='success' className='m-3'>身分証の提出が完了しました。確認が終わったら反映されます。</Alert> : ""}
                        {isCompleted ? <Alert severity='success' className='m-3'>身分証の確認が完了しました。</Alert> : ""}
                        {activeStep === -1 ? "" : <LoadingButton variant='contained' className='m-3 mb-5' onClick={() => {
                            if(activeStep === 0){
                                setLoading(true)
                                let sei = document.getElementById("sei").value
                                let mei = document.getElementById("mei").value
                                let seiKana = document.getElementById("sei_kana").value
                                let meiKana = document.getElementById("mei_kana").value
                                let postCode = document.getElementById("post-code").value
                                let prefecture = document.getElementById("prefecture").value
                                let address1 = document.getElementById("address1").value
                                let address2 = document.getElementById("address2").value
                                let address3 = document.getElementById("address3").value
                                baseIDRegist(sei,mei,seiKana,meiKana,sex,year,month,day,countryCode,postCode,prefecture,address1,address2,address3).then(r => {
                                    if(r.result){
                                        getIDInfo().then(r => {
                                            if(r.result){
                                                setIDInfo(r.data)
                                                setActiveStep(r.data.status)
                                                setMessage()
                                            }
                                        })
                                    } else {
                                        setMessage(r.errors)
                                    }
                                    setLoading(false)
                                })
                            }
                            if(activeStep === 1){
                                setLoading(true)
                                idImageRegist(identificationDiv,identificationImage1,identificationImage2,identificationImage3,identificationSelfie).then(r => {
                                    if(r.result){
                                        getIDInfo().then(r => {
                                            if(r.result){
                                                setIDInfo(r.data)
                                                setActiveStep(r.data.status)
                                                setMessage()
                                            }
                                        })
                                    } else {
                                        setMessage(r.errors)
                                    }
                                    setLoading(false)
                                })
                            }
                        }} style={{display:activeStep > 1 || isCompleted ? "none" : "block"}} loading={loading} disabled={false/*registedStatus === 0 && loginInfo.id_auth === 0 && loginInfo.plan === ""*/}>登録</LoadingButton>
                        }
                    </Box>
                    {activeStep === 1 ? (
                        <>
                        <h5>利用できる書類</h5>
                        <Table striped bordered hover style={{width:"100%"}}>
                            <thead>
                                <tr><th>本人確認書類</th><th>提出範囲</th><th>注意事項</th></tr>
                            </thead>
                            <tbody>
                                <tr><td>マイナンバーカード</td><td>両面</td><td>有効期限内で顔写真付きであること。マイナンバー部分は黒塗りして提出必須。</td></tr>
                                <tr><td>パスポート</td><td>顔写真ページ、住所記入欄ページ</td><td>有効期限内で、日本国発行のものに限る。現住所以外は取り消し線などで無効化すること。</td></tr>
                                <tr><td>運転免許証<br />運転経歴証明書</td><td>両面</td><td>有効期限内であること。</td></tr>
                                <tr><td>健康保険証＋住民票</td><td>健康保険証の両面、住民票</td><td>住民票は発行から3か月以内であり、マイナンバーが記載されていないもの。現住所以外は取り消し線などで無効化すること。</td></tr>
                                <tr><td>住民基本台帳カード</td><td>両面</td><td>顔写真付きであること。</td></tr>
                                <tr><td>特別永住者証明書</td><td>両面</td><td>有効期限内であること。</td></tr>
                                <tr><td>居住国政府発行の身分証明書(日本国外居住者の場合)</td><td>両面</td><td>有効期限内であり、現住所が確認できること。顔写真付きであること。</td></tr>
                            </tbody>
                        </Table>
                        </>
                    ) : ""}
                </Col>
            </Row>
        </Container>
        <Footer />
    </div>
    )
}

export default IDConfirmation;
